const Config = {
  app_storage_prefix: "teamsite-prod",
  api_server: "/api",
  socket_server: "/",
  auth: {
    clientId: "659bd61576780fe1ef680ee9",
  }
};
export default Config;
